import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "estate-card__photos" }
const _hoisted_2 = { class: "estate-card__info" }
const _hoisted_3 = { class: "estate-card__actions" }
const _hoisted_4 = { class: "estate-card__address" }
const _hoisted_5 = {
  key: 0,
  class: "estate-card__contact"
}
const _hoisted_6 = { class: "estate-card__person" }
const _hoisted_7 = {
  key: 0,
  class: "estate-card__logo"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AdListGallery = _resolveComponent("AdListGallery")!
  const _component_AdLabels = _resolveComponent("AdLabels")!
  const _component_AdListItemCompare = _resolveComponent("AdListItemCompare")!
  const _component_AdListItemLike = _resolveComponent("AdListItemLike")!
  const _component_AdListItemFavorite = _resolveComponent("AdListItemFavorite")!
  const _component_AdListItemPrice = _resolveComponent("AdListItemPrice")!
  const _component_AdListItemParams = _resolveComponent("AdListItemParams")!
  const _component_ResizableImage = _resolveComponent("ResizableImage")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.classId, "estate-card estate-card--rows"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_AdListGallery, {
        images: _ctx.ad.images,
        adGuid: _ctx.ad.adGuid,
        estateType: _ctx.ad.estateType,
        estateSubType: _ctx.ad.estateSubType,
        imageLimitCount: _ctx.imageLimitCount,
        width: 250,
        height: 180
      }, null, 8, ["images", "adGuid", "estateType", "estateSubType", "imageLimitCount"]),
      _createVNode(_component_AdLabels, { ad: _ctx.ad }, null, 8, ["ad"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_AdListItemCompare, { ad: _ctx.ad }, null, 8, ["ad"]),
        _createVNode(_component_AdListItemLike, { ad: _ctx.ad }, null, 8, ["ad"]),
        _createVNode(_component_AdListItemFavorite, { ad: _ctx.ad }, null, 8, ["ad"])
      ]),
      _createVNode(_component_AdListItemPrice, { ad: _ctx.ad }, null, 8, ["ad"]),
      _createVNode(_component_AdListItemParams, { ad: _ctx.ad }, null, 8, ["ad"]),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.address), 1),
      (_ctx.isEstateAgency)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_router_link, {
                to: { name: 'AdAgentList', params: { urlName: _ctx.ad.estateAgentUrlName } }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ResizableImage, {
                    classes: "estate-card__person-photo",
                    url: _ctx.ad.photoRelativeUrl,
                    onClick: _ctx.onAgentSelect,
                    width: 135,
                    height: 135,
                    placeholder: "img/no-photo-user.png",
                    backgroundImage: true
                  }, null, 8, ["url", "onClick"])
                ]),
                _: 1
              }, 8, ["to"])
            ]),
            (!_ctx.isEstateAgencyMode)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(_component_router_link, {
                    to: { name: 'AdAgencyList', params: { urlName: _ctx.ad.estateAgencyUrlName } }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ResizableImage, {
                        classes: "estate-agency-logo",
                        url: _ctx.ad.logoRelativeUrl,
                        placeholder: "img/no-logo-agency.png",
                        width: 80,
                        height: 45,
                        alt: "agency",
                        onClick: _ctx.onAgencySelect
                      }, null, 8, ["url", "onClick"])
                    ]),
                    _: 1
                  }, 8, ["to"])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}